import { AcceptedCookiePolicyEnum } from '~/types-and-enums/cookieTypes';

export const DefaultAcceptedCookiePolicy = AcceptedCookiePolicyEnum.None;

export const CookieStorageKey = 'cookie_policy';
